/*
 * @Author: tao_yang
 * @Date: 2022-11-17 14:57:11
 * @LastEditors: tao_yang
 * @LastEditTime: 2022-12-22 13:55:02
 * @Description:落地页 logos 组件
 */
import './Logoes.scss';
export default function (props) {
    let logo_1 =
        require('@/assets/img/landing/intelligentDesign/logo.png').default;
    let logo_2 =
        require('@/assets/img/landing/intelligentDesign/logo_1.png').default;
    let logo_3 =
        require('@/assets/img/landing/intelligentDesign/logo_2.png').default;
    let logo_4 =
        require('@/assets/img/landing/intelligentDesign/logo_3.png').default;
    let logo_5 =
        require('@/assets/img/landing/intelligentDesign/logo_4.png').default;
    let logo_6 =
        require('@/assets/img/landing/intelligentDesign/logo_5.png').default;

    let logo_hdd =
        require('@/assets/img/landing/intelligentDesign/logoes/logo.png').default;
    let logo_1_hdd =
        require('@/assets/img/landing/intelligentDesign/logoes/logo_1.png').default;
    let logo_2_hdd =
        require('@/assets/img/landing/intelligentDesign/logoes/logo_2.png').default;
    let logo_3_hdd =
        require('@/assets/img/landing/intelligentDesign/logoes/logo_3.png').default;
    let logo_4_hdd =
        require('@/assets/img/landing/intelligentDesign/logoes/logo_4.png').default;
    let logo_5_hdd =
        require('@/assets/img/landing/intelligentDesign/logoes/logo_5.png').default;
    const getLogoList = () => {
        if (props.isHDC) {
            return [
                {
                    img: logo_3,
                },
                {
                    img: logo_5,
                },
                {
                    img: logo_2,
                },
                {
                    img: logo_4,
                },
                {
                    img: logo_1,
                },
                {
                    img: logo_6,
                },
            ];
        } else {
            return [
                {
                    img: logo_2_hdd,
                },
                {
                    img: logo_5_hdd,
                },
                {
                    img: logo_1_hdd,
                },
                {
                    img: logo_3_hdd,
                },
                {
                    img: logo_hdd,
                },
                {
                    img: logo_4_hdd,
                },
            ];
        }
    };
    return (
        <div className={`logo-item-wrap ${props.isHDC ? 'hdc-logo' : ''}`}>
            {getLogoList().map((v, index) => (
                <div className="logo-item" key={index}>
                    <img src={v.img}></img>
                </div>
            ))}
        </div>
    );
}
